import { TypeOfProduct } from '@/manager/product/models/product.model';

export interface AcquiredCoursesInterface {
    products?: ClientProduct[];
    numberOfConvocations?: number;
    purchases?: any[];
    budgets?: any[];
    fiscalDataExtensions?: any[];
}

export interface ClientProduct {
    productName?: string;
    typeOfProduct?: TypeOfProduct;
    level?: string;
    repeater?: boolean;
    avatarTrainer?: string;
    participants?: ClientParticipants[];
}

export interface ClientParticipants {
    participantId?: string;
    date?: string;
    postpone?: boolean;
    checked?: boolean;
    out?: boolean;
    location?: string;
    trainer?: string;
}


export class AcquiredCourses implements AcquiredCoursesInterface {
    public products?: ClientProduct[];
    public numberOfConvocations?: number;
    public purchases?: any[];
    public budgets?: any[];
    public fiscalDataExtensions?: any[];
}

/**
 * Estado inicial con todas las listas vacías.
 *
 * La ficha de cliente accede a `.products`, `.purchases`, `.budgets` y
 * `.fiscalDataExtensions` sin comprobar si existen. Si la petición de cursos
 * adquiridos falla, el estado se queda como estuviera; con `{}` eso provocaba
 * un TypeError al pulsar una pestaña.
 */
export function emptyAcquiredCourses(): AcquiredCourses {
    return {
        numberOfConvocations: 0,
        products: [],
        purchases: [],
        budgets: [],
        fiscalDataExtensions: [],
    };
}
